import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Organization, OrganizationsService, OrganizationsStore } from '@cf/temp/services';
import { of, tap } from 'rxjs';

export const setOrganizationResolver: ResolveFn<Organization[]> = (route) => {
  const organizationsStore = inject(OrganizationsStore);
  const organizationsService = inject(OrganizationsService);
  const router = inject(Router);

  const organizationId = Number(route.paramMap.get('orgId'));

  const organizations = organizationsStore.ids().includes(organizationId)
    ? of(organizationsStore.entities())
    : organizationsService.fetchOrganizations();
  return organizations.pipe(
    tap((orgs) => {
      organizationsStore.setOrganizations(orgs);
      try {
        organizationsStore.selectEntity(organizationId);
      } catch (error) {
        router.navigate(['/error/404']);
        console.error(error);
      }
    }),
  );
};
